import {type ICarrierAdminLevelsConfig} from './CarrierAdminUserManagement'

enum carrierCode {
    AC = 'AC',
    AA = 'AA',
    NZ = 'NZ',
    MH = 'MH',
    UA = 'UA',
    AFKL = 'AF-KL',
    AF = 'AF',
    KL = 'KL',
    SK = 'SK',
    UW = 'UW',
    AI = 'AI',
    AZ = 'AZ'
}

export interface ICarrierAdminToolsAuthorizationConfig {
    isManageErrorMessages: string
    isHosttoHostTranslations: string
    isRestrictProducts: string
    isSpecializedBookingDatasetup: string
    isURNIATAAccountMapping: string
    isUploadProductSelector: string
    isManageSpecializedBookings: string
    isManageOffers: string
}

export const CarrierAdminToolsPrevilages = () => {
    const ACCarrierAdminTools: ICarrierAdminToolsAuthorizationConfig = {
        isManageErrorMessages: 'Enabled',
        isHosttoHostTranslations: 'Enabled',
        isRestrictProducts: 'Enabled',
        isSpecializedBookingDatasetup: 'Enabled',
        isURNIATAAccountMapping: 'Disabled',
        isUploadProductSelector: 'Disabled',
        isManageSpecializedBookings: 'Disabled',
        isManageOffers: 'Disabled'
    }

    const AACarrierAdminTools: ICarrierAdminToolsAuthorizationConfig = {
        isManageErrorMessages: 'Enabled',
        isHosttoHostTranslations: 'Enabled',
        isRestrictProducts: 'Enabled',
        isSpecializedBookingDatasetup: 'Disabled',
        isURNIATAAccountMapping: 'Enabled',
        isUploadProductSelector: 'Disabled',
        isManageSpecializedBookings: 'Enabled',
        isManageOffers: 'Disabled'
    }

    const NZCarrierAdminTools: ICarrierAdminToolsAuthorizationConfig = {
        isManageErrorMessages: 'Enabled',
        isHosttoHostTranslations: 'Enabled',
        isRestrictProducts: 'Enabled',
        isSpecializedBookingDatasetup: 'Disabled',
        isURNIATAAccountMapping: 'Disabled',
        isUploadProductSelector: 'Disabled',
        isManageSpecializedBookings: 'Enabled',
        isManageOffers: 'Disabled'
    }

    const MHCarrierAdminTools: ICarrierAdminToolsAuthorizationConfig = {
        isManageErrorMessages: 'Enabled',
        isHosttoHostTranslations: 'Enabled',
        isRestrictProducts: 'Enabled',
        isSpecializedBookingDatasetup: 'Disabled',
        isURNIATAAccountMapping: 'Disabled',
        isUploadProductSelector: 'Disabled',
        isManageSpecializedBookings: 'Enabled',
        isManageOffers: 'Disabled'
    }

    const UACarrierAdminTools: ICarrierAdminToolsAuthorizationConfig = {
        isManageErrorMessages: 'Enabled',
        isHosttoHostTranslations: 'Enabled',
        isRestrictProducts: 'Enabled',
        isSpecializedBookingDatasetup: 'Disabled',
        isURNIATAAccountMapping: 'Enabled',
        isUploadProductSelector: 'Disabled',
        isManageSpecializedBookings: 'Enabled',
        isManageOffers: 'Disabled'
    }

    const AFKLCarrierAdminTools: ICarrierAdminToolsAuthorizationConfig = {
        isManageErrorMessages: 'Enabled',
        isHosttoHostTranslations: 'Enabled',
        isRestrictProducts: 'Enabled',
        isSpecializedBookingDatasetup: 'Disabled',
        isURNIATAAccountMapping: 'Enabled',
        isUploadProductSelector: 'Enabled',
        isManageSpecializedBookings: 'Enabled',
        isManageOffers: 'Disabled'
    }

    const SKCarrierAdminTools: ICarrierAdminToolsAuthorizationConfig = {
        isManageErrorMessages: 'Enabled',
        isHosttoHostTranslations: 'Disabled',
        isRestrictProducts: 'Disabled',
        isSpecializedBookingDatasetup: 'Disabled',
        isURNIATAAccountMapping: 'Disabled',
        isUploadProductSelector: 'Disabled',
        isManageSpecializedBookings: 'Disabled',
        isManageOffers: 'Disabled'
    }

    const UWCarrierAdminTools: ICarrierAdminToolsAuthorizationConfig = {
        isManageErrorMessages: 'Enabled',
        isHosttoHostTranslations: 'Disabled',
        isRestrictProducts: 'Enabled',
        isSpecializedBookingDatasetup: 'Disabled',
        isURNIATAAccountMapping: 'Disabled',
        isUploadProductSelector: 'Disabled',
        isManageSpecializedBookings: 'Disabled',
        isManageOffers: 'Disabled'
    }

    const AICarrierAdminTools: ICarrierAdminToolsAuthorizationConfig = {
        isManageErrorMessages: 'Enabled',
        isHosttoHostTranslations: 'Disabled',
        isRestrictProducts: 'Enabled',
        isSpecializedBookingDatasetup: 'Disabled',
        isURNIATAAccountMapping: 'Disabled',
        isUploadProductSelector: 'Disabled',
        isManageSpecializedBookings: 'Disabled',
        isManageOffers: 'Disabled'
    }

    const AZCarrierAdminTools: ICarrierAdminToolsAuthorizationConfig = {
        isManageErrorMessages: 'Enabled',
        isHosttoHostTranslations: 'Enabled',
        isRestrictProducts: 'Enabled',
        isSpecializedBookingDatasetup: 'Disabled',
        isURNIATAAccountMapping: 'Disabled',
        isUploadProductSelector: 'Disabled',
        isManageSpecializedBookings: 'Enabled',
        isManageOffers: 'Disabled'
    }

    const adminHashMap = new Map<string, ICarrierAdminToolsAuthorizationConfig>()
        .set(carrierCode.AC, ACCarrierAdminTools)
        .set(carrierCode.AA, AACarrierAdminTools)
        .set(carrierCode.NZ, NZCarrierAdminTools)
        .set(carrierCode.MH, MHCarrierAdminTools)
        .set(carrierCode.UA, UACarrierAdminTools)
        .set(carrierCode.AFKL, AFKLCarrierAdminTools)
        .set(carrierCode.AF, AFKLCarrierAdminTools)
        .set(carrierCode.KL, AFKLCarrierAdminTools)
        .set(carrierCode.SK, SKCarrierAdminTools)
        .set(carrierCode.UW, UWCarrierAdminTools)
        .set(carrierCode.AI, AICarrierAdminTools)
        .set(carrierCode.AZ, AZCarrierAdminTools)

    return adminHashMap
}

export const CarrierAdminToolsAccess = () => {
    const carrierAdminConfigKey1: ICarrierAdminLevelsConfig = {
        isCarrierAdmin: true,
        isSecondLevelCarrierAdmin: true
    }

    const carrierAdminConfigValue1: ICarrierAdminToolsAuthorizationConfig = {
        isManageErrorMessages: 'Enabled',
        isHosttoHostTranslations: 'Enabled',
        isRestrictProducts: 'Enabled',
        isSpecializedBookingDatasetup: 'Enabled',
        isURNIATAAccountMapping: 'Enabled',
        isUploadProductSelector: 'Enabled',
        isManageSpecializedBookings: 'Enabled',
        isManageOffers: 'Disabled'
    }

    const carrierAdminConfigKey2: ICarrierAdminLevelsConfig = {
        isCarrierAdmin: true,
        isSecondLevelCarrierAdmin: false
    }

    const carrierAdminConfigValue2: ICarrierAdminToolsAuthorizationConfig = {
        isManageErrorMessages: 'Disabled',
        isHosttoHostTranslations: 'Disabled',
        isRestrictProducts: 'Disabled',
        isSpecializedBookingDatasetup: 'Disabled',
        isURNIATAAccountMapping: 'Disabled',
        isUploadProductSelector: 'Disabled',
        isManageSpecializedBookings: 'Enabled',
        isManageOffers: 'Disabled'
    }

    const carrierAdminConfigKey3: ICarrierAdminLevelsConfig = {
        isCarrierAdmin: false,
        isSecondLevelCarrierAdmin: true
    }

    const carrierAdminConfigValue3: ICarrierAdminToolsAuthorizationConfig = {
        isManageErrorMessages: 'Disabled',
        isHosttoHostTranslations: 'Disabled',
        isRestrictProducts: 'Disabled',
        isSpecializedBookingDatasetup: 'Disabled',
        isURNIATAAccountMapping: 'Disabled',
        isUploadProductSelector: 'Disabled',
        isManageSpecializedBookings: 'Disabled',
        isManageOffers: 'Enabled'
    }

    const carrierAdminConfigKey4: ICarrierAdminLevelsConfig = {
        isCarrierAdmin: false,
        isSecondLevelCarrierAdmin: false
    }

    const carrierAdminConfigValue4: ICarrierAdminToolsAuthorizationConfig = {
        isManageErrorMessages: 'Disabled',
        isHosttoHostTranslations: 'Disabled',
        isRestrictProducts: 'Disabled',
        isSpecializedBookingDatasetup: 'Disabled',
        isURNIATAAccountMapping: 'Disabled',
        isUploadProductSelector: 'Disabled',
        isManageSpecializedBookings: 'Disabled',
        isManageOffers: 'Enabled'
    }

    const adminHashMap = new Map<ICarrierAdminLevelsConfig, ICarrierAdminToolsAuthorizationConfig>()
    adminHashMap.set(carrierAdminConfigKey1, carrierAdminConfigValue1)
    adminHashMap.set(carrierAdminConfigKey2, carrierAdminConfigValue2)
    adminHashMap.set(carrierAdminConfigKey3, carrierAdminConfigValue3)
    adminHashMap.set(carrierAdminConfigKey4, carrierAdminConfigValue4)

    return adminHashMap
}

export const deafultCarrierToolsPrevilages: ICarrierAdminToolsAuthorizationConfig = {
    isManageErrorMessages: 'Disabled',
    isHosttoHostTranslations: 'Disabled',
    isRestrictProducts: 'Disabled',
    isSpecializedBookingDatasetup: 'Disabled',
    isURNIATAAccountMapping: 'Disabled',
    isUploadProductSelector: 'Disabled',
    isManageSpecializedBookings: 'Disabled',
    isManageOffers: 'Disabled'
}
